import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useSearchContext } from '../context/SearchContext';
import { useSelector } from 'react-redux';
import { useAreasFilters, useDevelopersFilters } from '../hooks/filters.hooks';

interface SearchTitleProps {
  resultsCount: number | null;
}

const SearchTitle = ({ resultsCount }: SearchTitleProps) => {
  const { t } = useTranslation('common');
  const { searchFiltersState } = useSearchContext();
  const { areas } = useAreasFilters();
  const { developers } = useDevelopersFilters();

  const isFetching = useSelector(
    (state: any) => state.searchResults.searchResults.isFetching
  );

  let searchType =
    searchFiltersState.searchFilters.category == 'property'
      ? t('properties')
      : t('compounds');

  const formatTitle = (results: string[]) => {
    if (results.length === 1) {
      return `${results[0]}`;
    }
    if (results.length === 2) {
      return `${results[0]} & ${results[1]}`;
    }
    if (results.length > 2) {
      return `${results[0]}, ${results[1]} ${t('and')} ${
        results.length - 2
      } ${t('more')}`;
    }
    return results[0];
  };

  const getTitle = () => {
    const selectedAreas = areas.filter(area =>
      searchFiltersState.searchFilters.areas.includes(area.value)
    );
    if (selectedAreas.length) {
      return `${searchType} ${t('in')} ${formatTitle(
        selectedAreas.map(area => area.options.displayedValue)
      )}`;
    }
    const selectedDevelopers = developers.filter(developer =>
      searchFiltersState.searchFilters.developers.includes(developer.value)
    );
    if (selectedDevelopers.length) {
      return `${searchType} ${t('in')} ${formatTitle(
        selectedDevelopers.map(developer => developer.options.displayedValue)
      )}`;
    }
    return `${searchType} ${t('in')} ${t('egypt')}`;
  };

  const getCount = () => {
    if (!isFetching && resultsCount) {
      return (
        <span className="total-results">
          {resultsCount} {t(searchType)}
        </span>
      );
    }
  };

  return (
    <Container>
      {getTitle()}
      {getCount()}{' '}
    </Container>
  );
};

const Container = styled.h1`
  color: #1a2028;
  font-family: materialBold;
  font-size: 26px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0;
  .total-results {
    color: #5b6573;
    text-align: center;
    font-family: materialMedium;
    font-size: 12px;
  }

  img {
    border-radius: 46px;
    border: 1px solid #d3dbe6;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    font-size: 21px;

    .total-results {
      font-size: 11px;
    }
  }
`;

export default SearchTitle;
